<script>
import moment from "moment";
export default {
  props: ["beritaDetail"],
  methods: {
    formattedDate(date) {
      moment.locale("id");
      return moment(date).format("DD MMMM YYYY");
    },
  },
};
</script>
<template>
  <div class="section-detail-berita blog-inner">
    <div class="media">
      <div class="image">
        <img :src="beritaDetail.image" alt="image" />
      </div>
    </div>
    <div class="content">
      <ul class="meta">
        <li>
          {{ formattedDate(beritaDetail.published_at) }}
        </li>
      </ul>
      <h2 class="title">{{ beritaDetail.title }}</h2>
      <div
        class="desc section-space--bottom--30"
        v-html="beritaDetail.body"
      ></div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/scss/6-responsive/template-blue/index.scss";
</style>
